<template>
	<section>
		<common-modal :is-show-close="isShowClose">
		  <div class="pay-wrap">
		    <div class="logo"></div>
		    <!-- 追加费用成功 -->
		    <div v-if="type == 'add'" class="pay-c">
		      <p class="text">支付成功</p>
		      <p class="text">若订单未成功，追加费用将一并退还</p>
		      <div class="btn-wrap">
		        <div class="go-order" @click="backList">返回列表</div>
		        <div class="look-order" @click="lookForOrder">查看详情</div>
		      </div>
		    </div>
		
		    <!-- 支付成功 -->
		    <div v-else class="pay-c">
		      <p class="money">￥{{ payPrice }}</p>
		      <p class="menber-discount" v-if="isMember == 2">
		        会员已优惠
		        <span>￥{{ memberDiscount }}</span>
		      </p>
		
		      <div class="tips-wrap">
		        <div>
		          <img src="@/assets/img/question.png" @click="isPlanShow=true" />
		          <span class="tips">保障计划：处理周期为五天</span>
		        </div>
		        <p>未成功订单随时退</p>
		      </div>
		
		      <div class="btn-wrap">
		        <div class="go-order" @click="backList">返回列表</div>
		        <div class="look-order" @click="lookForOrder">查看订单</div>
		      </div>
		    </div>
		  </div>
		</common-modal>
		
		<!-- 保障计划 -->
		<support-plan-modal v-if="isPlanShow" @close="isPlanShow = false" @showAgreeMent="isShowAgree = true"></support-plan-modal>
		<!-- 下单协议 -->
		<agree-ment-modal v-if="isShowAgree" @close="isShowAgree = false;isPlanShow = true"></agree-ment-modal>
	</section>
</template>

<script>
import commonModal from '@/components/commonModal.vue';
import { userInfo } from '@/api/common.js';
import agreeMentModal from '@/components/agreeMentModal';
import supportPlanModal from '@/components/supportPlanModal';
export default {
  components: {
    commonModal,
	agreeMentModal,
	supportPlanModal
  },

  props: {
    chargeMoney: {
      type: String,
      default: ''
    },

    type: {
      type: String,
      default: 'pay'
    },

    order_uuid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
		isPlanShow:false,
		isShowAgree:false,
      isShowClose: false,
      isMember: null,
      memberDiscount: '', // 会员优惠金额
      payPrice: '' // 实际支付的金额
    };
  },

  created() {
    var userInfo = this.$store.state.userInfo;
    if (userInfo.is_member) {
      this.isMember = userInfo.is_member;
      if (this.isMember == '2' && this.type != 'add') { // 会员,并且非追加订单
        this.memberDiscount = (Number(this.chargeMoney) / Number(userInfo.member_discount) - Number(this.chargeMoney)).toFixed(2);
        this.payPrice = this.chargeMoney;
      } else {
        this.payPrice = this.chargeMoney;
      }
    } else {
      this.payPrice = this.chargeMoney;
    }
  },

  methods: {
    async getUserInfo() {
      const { data, status } = await userInfo();
      if (status == '200') {
        if (data.is_member) {
          this.isMember = data.is_member;
          if (this.isMember == '2' && this.type != 'add') {
            // 会员,并且非追加订单
            this.memberDiscount = (Number(this.chargeMoney) / Number(data.member_discount) - Number(this.chargeMoney)).toFixed(2);
            this.payPrice = this.chargeMoney;
          } else {
            this.payPrice = this.chargeMoney;
          }
        } else {
          this.payPrice = this.chargeMoney;
        }
      }
    },

    // 返回列表
    backList() {
      if (this.$route.path == '/order-list') {
        this.$emit('backList');
      } else {
        this.$router.push({ path: './order-list' });
      }
    },

    // 查看订单
    lookForOrder() {
      if (this.$route.path == '/order-detail') {
			 this.$emit('backDetail');
      } else {
        this.$router.push({ path: './order-detail', query: { order_uuid: this.order_uuid } });
      }
    },

    async submit() {}
  }
};
</script>

<style lang="scss" scoped>
textarea::-webkit-input-placeholder {
	@include textarea-placeholder;
}

textarea::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	@include textarea-placeholder;
}

textarea:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	@include textarea-placeholder;
}

textarea:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	@include textarea-placeholder;
}

.pay-wrap {
	padding: 40px;
	.logo {
		width: 60px;
		height: 60px;
		margin: 0 auto;
		background: url(../assets/img/pay_success.png) no-repeat center;
		background-size: 100%;
	}
	.pay-c {
		margin-top: 30px;
		.money {
			text-align: center;
			@include font-style;
			font-size: 20px;
			color: #141414;
			font-weight: bold;
		}
		.menber-discount {
			text-align: center;
			@include font-style;
			font-size: 16px;
			color: #999;
			margin-top: 10px;
		}
		.text {
			@include font-style;
			font-size: 18px;
			text-align: center;
			color: #141414;
			margin-top: 20px;
		}
	}

	.tips-wrap {
		margin-top: 30px;
		div {
			display: flex;
			align-items: center;
			justify-content: center;
			img {
				@include cursor-style;
				width: 14px;
				height: 14px;
				margin-right: 10px;
			}
			span {
				@include font-style;
				font-size: 16px;
				color: #999;
			}
		}
		p {
			text-align: center;
			@include font-style;
			font-size: 16px;
			color: #999;
			line-height: 30px;
		}
	}

	//弹框按钮
	.btn-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		margin-top: 36px;

		.go-order {
			@include cursor-style;
			width: 100px;
			height: 36px;
			line-height: 36px;
			box-sizing: border-box;
			text-align: center;
			background: #ff8e1c;
			box-shadow: 1px 3px 6px 0px rgba(102, 102, 102, 0.16);
			border-radius: 5px;
			font-size: 15px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #ffffff;
		}

		.look-order {
			@include cursor-style;
			@extend .go-order;
			font-weight: 400;
			background: #ffffff;
			border: 1px solid #9a9a9a;
			color: #9a9a9a;
			margin-left: 20px;
		}
	}
}
</style>
